import { interface___modal } from "../../interfaces/interface.modals";

//	P R O P S

export interface props___MdDishViewModal extends interface___modal {

	dish_id: string | null,
	
}

//	S T A T E

export interface state___MdDishViewModal {

	dish___props: any | null,
	dish___props___is_loading: boolean,

}

//	S T A T E   D E F A U L T

export const state___MdDishViewModal___default: state___MdDishViewModal = {

	dish___props: null,
	dish___props___is_loading: true,

}